export default "__VITE_ASSET__COkBjipQ__"